import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaSave } from 'react-icons/fa';
import Loader from '../../components/layout/Loader';
import Message from '../../components/layout/Message';
import { useGetEventByIdQuery, useUpdateEventMutation } from '../../slices/promotionApiSlice';

const PromotionEditScreen = () => {
    const { id: eventId } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [icon, setIcon] = useState('star');
    const [gradient, setGradient] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [keywords, setKeywords] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [startMonth, setStartMonth] = useState(1);
    const [startDay, setStartDay] = useState(1);
    const [endMonth, setEndMonth] = useState(1);
    const [endDay, setEndDay] = useState(1);
    const [link, setLink] = useState('');

    const { data: event, isLoading, error } = useGetEventByIdQuery(eventId);
    const [updateEvent, { isLoading: loadingUpdate }] = useUpdateEventMutation();

    useEffect(() => {
        if (event) {
            setTitle(event.title);
            setDescription(event.description);
            setIcon(event.icon);
            setGradient(event.gradient);
            setButtonText(event.buttonText);
            setKeywords(event.keywords.join(', '));
            setIsActive(event.isActive);
            
            if (event.startDate) {
                setStartMonth(event.startDate.month);
                setStartDay(event.startDate.day);
            }
            if (event.endDate) {
                setEndMonth(event.endDate.month);
                setEndDay(event.endDate.day);
            }
            
            setLink(event.link || '');
        }
    }, [event]);

    const submitHandler = async (e) => {
        e.preventDefault();
        try {
            await updateEvent({
                _id: eventId,
                title,
                description,
                icon,
                gradient,
                buttonText,
                keywords: keywords.split(',').map((k) => k.trim()),
                isActive,
                startDate: {
                    day: Number(startDay),
                    month: Number(startMonth)
                },
                endDate: {
                    day: Number(endDay),
                    month: Number(endMonth)
                },
                link
            }).unwrap();
            toast.success('Evento actualizado correctamente');
            navigate('/admin/eventlist');
        } catch (err) {
            toast.error(err?.data?.message || err.error);
        }
    };

    const months = [
        { value: 1, label: 'Enero' },
        { value: 2, label: 'Febrero' },
        { value: 3, label: 'Marzo' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Mayo' },
        { value: 6, label: 'Junio' },
        { value: 7, label: 'Julio' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Septiembre' },
        { value: 10, label: 'Octubre' },
        { value: 11, label: 'Noviembre' },
        { value: 12, label: 'Diciembre' }
    ];

    return (
        <Container className="py-5">
            <div className="d-flex align-items-center mb-4">
                <Link to="/admin/eventlist" className="btn btn-light rounded-circle shadow-sm me-3 p-2">
                    <FaArrowLeft />
                </Link>
                <h2 className="fw-bold mb-0">Editar Evento</h2>
            </div>

            {loadingUpdate && <Loader />}
            
            {isLoading ? (
                <Loader />
            ) : error ? (
                <Message variant="danger">{error?.data?.message || error.error}</Message>
            ) : (
                <Row className="justify-content-center">
                    <Col lg={8}>
                        <Card className="shadow-sm border-0 rounded-4">
                            <Card.Body className="p-4 p-md-5">
                                <Form onSubmit={submitHandler}>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group controlId="title" className="mb-4">
                                                <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Título del Evento</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Ej: ¡Feliz Navidad, {name}!"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    className="form-control-lg rounded-3 fs-6"
                                                />
                                                <Form.Text className="text-muted small">
                                                    Tip: Usa <strong>{'{name}'}</strong> para personalizar con el nombre del usuario.
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group controlId="description" className="mb-4">
                                                <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Descripción</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    placeholder="Describe brevemente el evento..."
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    className="rounded-3"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="icon" className="mb-4">
                                                <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Icono</Form.Label>
                                                <Form.Select
                                                    value={icon}
                                                    onChange={(e) => setIcon(e.target.value)}
                                                    className="form-select-lg rounded-3 fs-6"
                                                >
                                                    <option value="star">⭐ Estrella</option>
                                                    <option value="gift">🎁 Regalo</option>
                                                    <option value="heart">❤️ Corazón</option>
                                                    <option value="shopping-bag">🛍️ Bolsa</option>
                                                    <option value="sun">☀️ Sol</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="gradient" className="mb-4">
                                                <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Estilo (Gradiente CSS)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="linear-gradient(...)"
                                                    value={gradient}
                                                    onChange={(e) => setGradient(e.target.value)}
                                                    className="form-control-lg rounded-3 fs-6"
                                                />
                                                <div className="mt-2 rounded-2" style={{ height: '8px', background: gradient }}></div>
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="buttonText" className="mb-4">
                                                <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Texto del Botón</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Ej: Ver Ofertas"
                                                    value={buttonText}
                                                    onChange={(e) => setButtonText(e.target.value)}
                                                    className="form-control-lg rounded-3 fs-6"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="link" className="mb-4">
                                                <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Enlace (Opcional)</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="/search/navidad"
                                                    value={link}
                                                    onChange={(e) => setLink(e.target.value)}
                                                    className="form-control-lg rounded-3 fs-6"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group controlId="keywords" className="mb-4">
                                        <Form.Label column='sm' className="small fw-bold text-muted text-uppercase">Palabras Clave</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="navidad, regalo, luces (separadas por coma)"
                                            value={keywords}
                                            onChange={(e) => setKeywords(e.target.value)}
                                            className="form-control-lg rounded-3 fs-6"
                                        />
                                    </Form.Group>

                                    <Row>
                                        <Col md={12}>
                                            <h6 className="small fw-bold text-muted text-uppercase mb-3">Fecha de Inicio</h6>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="startMonth" className="mb-4">
                                                <Form.Label column='sm' className="small text-muted">Mes</Form.Label>
                                                <Form.Select
                                                    value={startMonth}
                                                    onChange={(e) => setStartMonth(e.target.value)}
                                                    className="form-select-lg rounded-3 fs-6"
                                                >
                                                    {months.map(m => (
                                                        <option key={m.value} value={m.value}>{m.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="startDay" className="mb-4">
                                                <Form.Label column='sm' className="small text-muted">Día</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    max="31"
                                                    value={startDay}
                                                    onChange={(e) => setStartDay(e.target.value)}
                                                    className="form-control-lg rounded-3 fs-6"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={12}>
                                            <h6 className="small fw-bold text-muted text-uppercase mb-3">Fecha de Fin</h6>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="endMonth" className="mb-4">
                                                <Form.Label column='sm' className="small text-muted">Mes</Form.Label>
                                                <Form.Select
                                                    value={endMonth}
                                                    onChange={(e) => setEndMonth(e.target.value)}
                                                    className="form-select-lg rounded-3 fs-6"
                                                >
                                                    {months.map(m => (
                                                        <option key={m.value} value={m.value}>{m.label}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="endDay" className="mb-4">
                                                <Form.Label column='sm' className="small text-muted">Día</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    max="31"
                                                    value={endDay}
                                                    onChange={(e) => setEndDay(e.target.value)}
                                                    className="form-control-lg rounded-3 fs-6"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group controlId="isActive" className="mb-5">
                                        <div className="d-flex align-items-center p-3 border rounded-3 bg-light cursor-pointer" onClick={() => setIsActive(!isActive)}>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-0 fw-bold">Estado del Evento</h6>
                                                <small className="text-muted">
                                                    {isActive ? 'El evento está visible para los usuarios' : 'El evento está oculto'}
                                                </small>
                                            </div>
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                checked={isActive}
                                                onChange={(e) => setIsActive(e.target.checked)}
                                                className="fs-4"
                                            />
                                        </div>
                                    </Form.Group>

                                    <div className="d-grid">
                                        <Button 
                                            type="submit" 
                                            variant="primary" 
                                            size="lg" 
                                            className="rounded-pill fw-bold py-3 shadow-sm"
                                            style={{ backgroundColor: '#b5430f', borderColor: '#b5430f' }}
                                        >
                                            <FaSave className="me-2" /> Guardar Cambios
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default PromotionEditScreen;
